import React, { useState, useContext, useEffect } from 'react';
import moment from 'moment';
import {
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  ConversationHeader,
  TypingIndicator,
  Avatar as ChatAvatar,
  MessageGroup,
} from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import '../../chatbot-settings/chat-interface/scss/chat-interface-overrides.scss';
import { getChatResponse } from 'api-services/chat-bot';
import ChatBotContext from 'hooks/chat-bot-context';
import { CHAT_BOT } from 'utilities/constants';
import { useNavigate } from 'react-router';

const ChatbotDemo = () => {
  const navigate = useNavigate();
  const { selectedBot, botName } = useContext(ChatBotContext);
  const [messages, setMessages] = useState([]); // REMOVE THIS SAMPLE DATA AFTER API INTEGRATION
  const [userText, setUserText] = useState('');
  const [typing, setTyping] = useState(false);
  const [conversationId, setConversationId] = useState(null);

  useEffect(() => {
    if (!selectedBot) {
      navigate('/chatbots');
    }
  }, [selectedBot]);

  const submitMessage = async () => {
    if (!userText.trim()) {
      return;
    }

    messages.push({
      content: userText,
      entity_type: 'You',
      timestamp: moment().format('hh:mm a'),
    });

    setMessages([...messages]);
    setTyping(true);
    try {
      const response = await getChatResponse({
        bot_id: selectedBot,
        user_message: userText,
        ...(conversationId && { conversation_id: conversationId }),
      });
      setTyping(false);
      if (response.status === 200) {
        messages.push({
          content: response.data.message,
          entity_type: CHAT_BOT.BOT,
          timestamp: moment(response.data.timestamp).format('hh:mm a'),
        });
        setConversationId(response.data.conversation_id);
        setMessages([...messages]);
      }
    } catch (e) {
      setTyping(false);
      console.log(e);
    }
  };
  return (
    <div className='chatbot-demo'>
      <ChatContainer>
        <ConversationHeader>
          <ConversationHeader.Content userName={botName || 'Anonymous'} />
          <ChatAvatar src={CHAT_BOT.BOT_IMAGE} name='AI BOT' />
        </ConversationHeader>
        <MessageList typingIndicator={typing && <TypingIndicator content={'Bot is typing'} />}>
          {messages?.map((message, index) => (
            <MessageGroup
              direction={message.entity_type === CHAT_BOT.BOT ? 'incoming' : 'outgoing'}
              sentTime={message.timestamp}
              key={message.timestamp}>
              <MessageGroup.Messages>
                <Message
                  key={index}
                  model={{
                    message: message.content,
                    sender: message.entity_type,
                  }}>
                  {message.entity_type === CHAT_BOT.BOT ? (
                    <ChatAvatar src={CHAT_BOT.BOT_IMAGE} name={message.entity_type} />
                  ) : (
                    <></>
                  )}
                </Message>
                <Message.Footer sender={message.entity_type} sentTime={message.timestamp} />
              </MessageGroup.Messages>
            </MessageGroup>
          ))}
        </MessageList>
        <MessageInput
          placeholder='Type your message...'
          attachButton={false}
          sendOnReturnDisabled={false}
          onChange={(_, msg) => setUserText(msg)}
          onSend={submitMessage}
        />
      </ChatContainer>
    </div>
  );
};

export default ChatbotDemo;
